import mozzoAppInstitutionalLogoUrl from "../../assets/branding/mozzoapp-institutional-icon.png";
import weRiderLogoUrl from "../../assets/branding/we-rider-logo.png";

export const MOZZOAPP_INSTITUTIONAL_LOGO_URL = mozzoAppInstitutionalLogoUrl;
export const WE_PEDIDOS_LOGO_URL = "/we-pedidos-logo.png?v=20260818";
export const WE_RIDER_LOGO_URL = weRiderLogoUrl;
const MOZZOAPP_INSTITUTIONAL_ICON_URL = `${mozzoAppInstitutionalLogoUrl}?v=20260605`;
const FAVICON_RENDER_SIZE = 192;
const FAVICON_SAFE_PADDING_RATIO = 0.12;
const faviconRenderCache = new Map();
let activeFaviconRequestId = 0;

const ensureHeadLink = (rel) => {
  if (typeof document === "undefined") {
    return null;
  }

  let link = document.querySelector(`link[rel='${rel}']`);

  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", rel);
    document.head.appendChild(link);
  }

  return link;
};

const setHeadIconLink = (rel, href, type = "image/png") => {
  const link = ensureHeadLink(rel);

  if (!link) {
    return;
  }

  link.setAttribute("href", href);
  if (type) {
    link.setAttribute("type", type);
  } else {
    link.removeAttribute("type");
  }
};

const renderSquaredFaviconDataUrl = (iconUrl) =>
  new Promise((resolve) => {
    if (typeof document === "undefined" || typeof window === "undefined") {
      resolve(iconUrl);
      return;
    }

    if (!iconUrl) {
      resolve(MOZZOAPP_INSTITUTIONAL_ICON_URL);
      return;
    }

    const cachedValue = faviconRenderCache.get(iconUrl);

    if (cachedValue) {
      resolve(cachedValue);
      return;
    }

    const image = new window.Image();
    image.decoding = "async";
    image.crossOrigin = "anonymous";

    image.onload = () => {
      try {
        const canvas = document.createElement("canvas");
        canvas.width = FAVICON_RENDER_SIZE;
        canvas.height = FAVICON_RENDER_SIZE;
        const context = canvas.getContext("2d");

        if (!context) {
          resolve(iconUrl);
          return;
        }

        const safePadding = FAVICON_RENDER_SIZE * FAVICON_SAFE_PADDING_RATIO;
        const maxDrawableWidth = FAVICON_RENDER_SIZE - safePadding * 2;
        const maxDrawableHeight = FAVICON_RENDER_SIZE - safePadding * 2;
        const scale = Math.min(
          maxDrawableWidth / Math.max(1, image.naturalWidth || image.width || 1),
          maxDrawableHeight / Math.max(1, image.naturalHeight || image.height || 1)
        );
        const drawWidth = Math.max(
          1,
          Math.round((image.naturalWidth || image.width || 1) * scale)
        );
        const drawHeight = Math.max(
          1,
          Math.round((image.naturalHeight || image.height || 1) * scale)
        );
        const drawX = Math.round((FAVICON_RENDER_SIZE - drawWidth) / 2);
        const drawY = Math.round((FAVICON_RENDER_SIZE - drawHeight) / 2);

        context.clearRect(0, 0, FAVICON_RENDER_SIZE, FAVICON_RENDER_SIZE);
        context.drawImage(image, drawX, drawY, drawWidth, drawHeight);

        const dataUrl = canvas.toDataURL("image/png");
        faviconRenderCache.set(iconUrl, dataUrl);
        resolve(dataUrl);
      } catch (error) {
        resolve(iconUrl);
      }
    };

    image.onerror = () => {
      resolve(iconUrl);
    };

    image.src = iconUrl;
  });

const applyHeadIconHref = (href) => {
  if (typeof document === "undefined") {
    return;
  }

  const resolvedIconUrl = href || MOZZOAPP_INSTITUTIONAL_ICON_URL;

  Array.from(document.querySelectorAll("link[rel*='icon']")).forEach((link) => {
    const rel = String(link.getAttribute("rel") || "").toLowerCase();

    if (rel.includes("apple-touch-icon")) {
      link.setAttribute("href", resolvedIconUrl);
      return;
    }

    if (rel.includes("icon")) {
      link.setAttribute("href", resolvedIconUrl);
      link.setAttribute("type", "image/png");
    }
  });

  setHeadIconLink("icon", resolvedIconUrl);
  setHeadIconLink("shortcut icon", resolvedIconUrl);
  setHeadIconLink("apple-touch-icon", resolvedIconUrl, "");
};

export const applyHeadBrandingAssets = (iconUrl) => {
  const resolvedIconUrl = iconUrl || MOZZOAPP_INSTITUTIONAL_ICON_URL;
  const requestId = ++activeFaviconRequestId;

  return renderSquaredFaviconDataUrl(resolvedIconUrl).then((finalIconUrl) => {
    if (requestId !== activeFaviconRequestId) {
      return;
    }

    applyHeadIconHref(finalIconUrl || resolvedIconUrl);
  });
};

export const applyInstitutionalBrandingAssets = () => {
  return applyHeadBrandingAssets(MOZZOAPP_INSTITUTIONAL_ICON_URL);
};
